import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { useStyles as classes } from '../styles/styles';

const Popup = (props) => {
    const open = props.open;
    const setDone = props.setDone;
    const component = props.component;
    const maxWidth = props.maxWidth;
    const title = props.title || "Dialog Title";

    return (
        <>
            <Dialog
                open={open}
                maxWidth={maxWidth ? maxWidth : 'md'}
                fullWidth
                sx={{...classes.dialog, backgroundColor: 'transparent'}}
                scroll="paper"
                aria-describedby="dialog-description"
                tabIndex="-1"
                aria-modal="true"
                onClose={() => setDone(true)}
                slotProps={{
                    paper: {
                        'aria-label': title
                    },
                    backdrop: {
                        'aria-hidden': 'true'
                    }
                }}
            >
                <DialogContent dividers>
                    <DialogContentText id="dialog-description" component="div">
                        {component}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setDone(true)}>Close</Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default Popup;
